<script setup lang="ts">
import { defineProps } from "vue";

const props = defineProps<{
  isMobile: boolean;
}>();
</script>

<template>
  <div
    class="base-slide"
    :class="[props.isMobile ? 'slide-mobile' : 'slide-desktop']"
  >
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
.base-slide.slide-mobile {
  height: auto;
  width: 100%;
}

.base-slide.slide-desktop {
  height: 100%;
  width: auto;
}
</style>